<template>
  <div class="dashboard">
    <div class="filter-group gutter-bottom flex">
      <app-filter-group
          :reset="false"
          ref="app-filter-group"
          @query="query">
        <gj-country-server-select
            v-model="filter.countryMarket"
            :show-country="false"
            @input-market-option="marketOptionInput"
        ></gj-country-server-select>
        <gj-select-input
            :value="filter.timezone"
            :options="option.timezone"
            input-readonly
            input-disabled
            :input-clearable="false"
            :width="['160px', '160px']"
            class="timezone"
            @input-option="refreshTimezone($event)">
        </gj-select-input>
        <gj-select-input
            v-model="filter.keyword"
            :options="option.keyword"
            :width="['100px', '150px']"
        ></gj-select-input>
      </app-filter-group>
      <gj-tool-group help :marginBottom="false"></gj-tool-group>
    </div>
    <div v-record-scroll
         class="content-wrapper">
      <el-row class="gutter-bottom">
        <app-dashboard-sale-instant
            :country-market="filter.countryMarket"
            today
            :keyword="filter.keyword"
            :show-date="filter.timezone.value"
            :current-time="filter.timezone.value"
        ></app-dashboard-sale-instant>
      </el-row>
      <el-row class="gutter-bottom" style="flex: 1; overflow: auto; margin-bottom: 0; min-height: 510px">
        <app-dashboard-sale-instant-table
            :country-market="filter.countryMarket"
            :keyword="filter.keyword"
            :show-date="filter.timezone.value"
            :PSTTime="PSTTime"
        ></app-dashboard-sale-instant-table>
      </el-row>
    </div>
  </div>
</template>

<script>
  import AppDashboardSaleInstant from "../components/sale/dashoboard-sale-instant";
  import AppDashboardSaleInstantTable from "../components/sale/dashboard-sale-instant-table";
  import {getInstantSaleTime} from "../../../../api/dashboard";
  import {optionText} from "../../../../filters";
  import {countryOption, timezoneOption} from "../../../../utils/options";
  import {isMeaningful} from "../../../../utils/common";
  import { queryMixin } from "@/minxins";

  export default {
    name: "app-seller-assistant",
    mixins: [queryMixin],
    components: {AppDashboardSaleInstantTable, AppDashboardSaleInstant},
    data() {
      return {
        PSTTime:'',
        filter: {
          countryMarket: null,
          tmpKeyword: {
            key: 'asin',
            value: null
          },
          keyword: {
            key: 'asin',
            value: null
          },
          timezone: {
            key: null,
            value: null
          },
        },
        option: {
          keyword: [
            {id: 'asin', text: 'ASIN'},
            {id: 'sku', text: 'SKU'},
            {id: 'msku', text: 'MSKU'},
            // {id: 'skuName', text: '产品名称'},
          ],
          timezone: [],
        },
        timezoneCodes: [],
        cacheOptions: {
          useCache: true,
        }
      };
    },
    created() {
      this.refreshTimezone();
    },
    methods: {
      $gjCacheCallback(params) {
        return {
          countryMarket: params.countryMarket,
        };
      },
      query() {
        if (isMeaningful(this.filter.timezone.key)) {
          this.refreshTimezone({id: this.filter.timezone.key});
        } else {
          this.refreshTimezone();
        }
      },
      refreshTimezone(option) {
        // 获取数据计算时间
        getInstantSaleTime()
          .then((data) => {
            if (data && data.length > 0) {
              this.option.timezone = data
                .filter(item => this._.size(this.timezoneCodes) === 0 || this.timezoneCodes.includes(item.id))
                .map(item => ({
                  id: item.id,
                  text: optionText(item.id, timezoneOption),
                  time: item.text || '各个站点市场时间'
                }));
              this.PSTTime = data.find(r => r.id ==='PST').text
              if (this.option.timezone.length > 0) {
                if (isMeaningful(option)) {
                  this.timezoneOptionInput(this.option.timezone.find(item => item.id === option.id));
                } else {
                  this.timezoneOptionInput(this.option.timezone[0]);
                }
              }
            }
          });
      },
      timezoneOptionInput(option) {
        this.filter.timezone = {
          key: option.id,
          value: option.time
        };
      },
      marketOptionInput(options) {
        // this.$refs['app-filter-group'].cacheDataFn()
        this.timezoneCodes = this._.uniq((options || []).map(item => {
          const find = countryOption.find(countryOption => countryOption.id === item.countryCode);
          return find ? find.timezone : null;
        }).filter(e => isMeaningful(e)));
        this.refreshTimezone();
        this.$nextTick(_ => {
          this.setCacheData()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";
  .filter-group{
    justify-content: space-between;
    
  }
  .filter-group.gutter-bottom{
    padding: 12px 24px 12px 16px;
    margin-bottom: 0;
  }
  /deep/ .operate-group{
    margin: 0;
  }
  /deep/ .content-wrapper{
    padding: 0 16px 16px;
    display: flex;
    flex-direction: column;
    
  }
</style>
